const state = {
    LabelYield: 3,
    LabelSurface: 4,
    LabelAdditionalParameters: 5
};

const getters = {
    labelYield: state => {
        return state.LabelYield;
    },
    labelSurface: state => {
        return state.LabelSurface;
    },
    labelAdditionalParameters: state => {
        return state.LabelAdditionalParameters;
    }
};


const mutations = {
    // Default input parameters
    UpdateLabelYield: (state, payload) => {
        state.LabelYield = payload;
    },
    UpdateLabelSurface: (state, payload) => {
        state.LabelSurface = payload;
    },
    LabelAdditionalParameters: (state, payload) => {
        state.LabelAdditionalParameters = payload;
    }
};


const actions = {
    UpdateLabelYield({ commit }, payload) {
        commit('UpdateLabelYield', payload);
    },
    UpdateLabelSurface({ commit }, payload) {
        commit('UpdateLabelSurface', payload);
    },
    LabelAdditionalParameters({ commit }, payload) {
        commit('LabelAdditionalParameters', payload);
    }
};

export default {
    state,
    getters,
    mutations,
    actions
};